import React from 'react';
import styled from 'styled-components';

import { KATANA_PERPS } from 'config/constants';

import QrSyncSteps from '../QrSyncSteps';

const Wrap = styled.div`
  text-align: center;
`;

const Heading = styled.h1`
  padding-top: 24px;
  margin: 0;
  line-height: normal;
`;

export default function QrSyncDescriptionMobile() {
  return (
    <Wrap>
      <Heading>
        Trade anytime, anywhere with
        <br />
        {KATANA_PERPS} Connect for mobile
      </Heading>
      <QrSyncSteps isDesktop={false} />
    </Wrap>
  );
}
